import RatingAuto from "./RatingAuto";

export default RatingAuto;